<template>
  <v-app style="background-color: white;">
    <v-card color="grey lighten-4" flat tile>
      <v-toolbar dense>
        <v-toolbar-title style="font-size:20px;"
          >Authorize Info</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <div>
          <v-btn color="error" @click="backToList()">Back</v-btn>
        </div>
      </v-toolbar>
    </v-card>

    <v-container v-if="errAuthInfo != ''">
      <p>
        Error:
        {{ errAuthInfo }}
      </p>
    </v-container>

    <iframe
      v-if="errAuthInfo == ''"
      :src="iFrameUrl"
      name="myFrame"
      height="100%"
      width="100%"
    ></iframe>
  </v-app>
</template>

<script>
import JS from '../services/JsonService'
export default {
  data() {
    return {
      rawHtml: '',
      errAuthInfo: '',
      iFrameUrl: ''
    }
  },
  created() {
    this.getAuthInfo()
  },
  destroyed() {
    //console.log('destroy')
  },
  methods: {
    getAuthInfo() {
      this.iFrameUrl = ''
      var authListInfo = JSON.parse(sessionStorage.getItem('authListInfo'))
      const url = 'Account/GetAuthInfo'
      const parameter = {
        Version: 1,
        AuthID: authListInfo.authid,
        TrnhdrID: authListInfo.hdrid,
        AuthType: authListInfo.authType
      }
      //console.log('parameter:', parameter)
      JS.request(url, parameter)
        .then(response => {
          //console.log(response.data)
          this.errAuthInfo = ''
          this.rawHtml = response.data

          var memberInfo = JSON.parse(sessionStorage.getItem('MemberInfo'))
          //console.log(memberInfo)
          this.iFrameUrl =
            'http://60.48.136.18:6788/api/Authorise/View/' +
            memberInfo.UserID +
            '/' +
            authListInfo.hdrid +
            '/' +
            authListInfo.authid
          //console.log(this.iFrameUrl)
        })
        .catch(error => {
          //console.log(error)
          this.errAuthInfo = error
        })
    },
    backToList() {
      sessionStorage.setItem(
        'authListInfo',
        JSON.stringify({
          authid: '',
          hdrid: '',
          authType: ''
        })
      )
      this.$router.replace('/authList')
    }
  }
}
</script>

<style></style>
